import statusImg from './statusImg';

export enum errorCodes {
  NOT_FOUND = '404',
  FORBIDDEN = '403',
  SERVER_ERROR = '500'
}

export type ErrorHandlerTypes = {
  [key in errorCodes]: {
    header: string;
    svg: string;
    title: string;
    message: string;
    buttonText: string;
    showDetails: boolean;
  };
};

const errors: ErrorHandlerTypes = {
  [errorCodes.FORBIDDEN]: {
    header: 'Error 403',
    svg: statusImg.FORBIDDEN,
    title: 'unauthorizedAccessTitle',
    message: 'unauthorizedAccessDescription',
    buttonText: 'loginLabel',
    showDetails: false
  },
  [errorCodes.NOT_FOUND]: {
    header: 'Error 404',
    svg: statusImg.PAGE_NOT_FOUND,
    title: 'pageNotFoundTitle',
    message: 'pageNotFoundDescription',
    buttonText: 'backLabel',
    showDetails: true
  },
  [errorCodes.SERVER_ERROR]: {
    header: 'Error 500',
    svg: statusImg.SERVER_ERROR,
    title: 'serverErrorTitle',
    message: 'serverErrorDesc',
    buttonText: 'reloadLabel',
    showDetails: true
  }
};

export default errors;
